import * as yup from 'yup'
import { INVALID_PRICE_FORMAT, REQUIRED_FIELD } from 'constants/errors'
import { priceReg } from 'constants/regExp'

export const schemaRefund = yup.object().shape({
  amount: yup.string().required(REQUIRED_FIELD).matches(priceReg, INVALID_PRICE_FORMAT),
})
